import Billing from '../../../../models/BillingDetails';
import { useQuery } from 'react-query';

function useBillingDetails() {
    return useQuery<Billing>('billing');
}

export default useBillingDetails;
